import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import { Badge } from '../ui/badge';

function fmtInt(n) {
  if (n == null) return '-';
  return Number(n).toLocaleString('en-GB');
}

// Shared by ClientInvoiceCensusPanel and SupplierInvoiceCensusPanel -- both
// responses carry the identical direction_reconciliation block (whole
// db.invoices collection, not scoped to one direction), so either panel
// alone shows the two-way payable + receivable + unclassifiable == total
// check without the operator needing to open both.
export function InvoiceDirectionReconciliationStrip({ reconciliation }) {
  if (!reconciliation) return null;
  const {
    total, payable_count, receivable_count, unclassifiable_count,
    unclassifiable_by_raw_value, reconciles,
  } = reconciliation;
  const unclassifiableEntries = Object.entries(unclassifiable_by_raw_value || {});

  return (
    <div className="space-y-1.5 pt-2 border-t" data-testid="invoice-direction-reconciliation">
      <div className="text-xs font-medium text-muted-foreground">
        Direction reconciliation (whole collection)
      </div>
      <div className="flex flex-wrap items-center gap-1 text-xs">
        <Badge variant="outline" className="text-[10px]">Total: {fmtInt(total)}</Badge>
        <Badge variant="outline" className="text-[10px]">Payable: {fmtInt(payable_count)}</Badge>
        <Badge variant="outline" className="text-[10px]">Receivable: {fmtInt(receivable_count)}</Badge>
        <Badge variant="outline" className="text-[10px]">Unclassifiable: {fmtInt(unclassifiable_count)}</Badge>
        {reconciles ? (
          <span className="flex items-center gap-1 text-emerald-700 dark:text-emerald-400">
            <CheckCircle2 className="h-3 w-3" /> buckets sum to total
          </span>
        ) : (
          <span className="flex items-center gap-1 text-red-600 dark:text-red-400">
            <AlertTriangle className="h-3 w-3" /> buckets DO NOT sum to total
          </span>
        )}
      </div>
      {unclassifiable_count > 0 && (
        <div
          className="flex items-start gap-1 p-2 rounded border border-amber-300 bg-amber-50 dark:border-amber-700 dark:bg-amber-950/30 text-amber-800 dark:text-amber-300"
          data-testid="invoice-direction-unclassifiable-flag"
        >
          <AlertTriangle className="h-3.5 w-3.5 mt-0.5 shrink-0" />
          <div className="space-y-1">
            <div>
              {fmtInt(unclassifiable_count)} invoice(s) have a `type` value that resolves to
              neither Payable nor Receivable -- invisible from both the Supplier and Client
              tabs at once. By raw stored value:
            </div>
            <div className="flex flex-wrap gap-1">
              {unclassifiableEntries.map(([value, count]) => (
                <Badge key={value} variant="outline" className="text-[10px]">
                  {value}: {count}
                </Badge>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
